import { BankHoliday } from '../../types/bank-holiday'
import { isWeekend } from '../date-utils'

/**
 * Computes the server-style default calculation code for an On Call day.
 *
 * - Weekends always return "2" (options [1, 2]).
 * - Weekdays return "1" (options [0.5, 1]).
 * - For non-US locations, a weekday that is a bank holiday returns "2" (treated
 *   like a weekend, options [1, 2]).
 * - For US locations (useCalculationCodes true or locationGroupId 7), bank
 *   holidays on weekdays are treated as normal weekdays and return "1"
 *   (options [0.5, 1]).
 *
 * Bank holiday matching is date-only (time-of-day ignored).
 */
export const getDefaultCalculationCode = (
  day: Date,
  bankHolidays: BankHoliday[] | null,
  locationGroupId?: number,
  useCalculationCodes?: boolean | null
): string => {
  const isUS = locationGroupId === 7 || useCalculationCodes === true

  if (isWeekend(day)) return '2'

  if (!isUS && bankHolidays && bankHolidays.length > 0) {
    const dayYMD = new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime()
    const isHoliday = bankHolidays.some(h => {
      const hd = h.holidayDate
      if (!hd) return false
      const hdAsDate = hd instanceof Date ? hd : new Date(hd)
      const hdYMD = new Date(
        hdAsDate.getFullYear(),
        hdAsDate.getMonth(),
        hdAsDate.getDate()
      ).getTime()
      return hdYMD === dayYMD
    })
    if (isHoliday) return '2'
  }

  return '1'
}
